import { render, staticRenderFns } from "./practicalMarkBi.vue?vue&type=template&id=69b883c8&"
import script from "./practicalMarkBi.vue?vue&type=script&lang=js&"
export * from "./practicalMarkBi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports